import {getCurrentYear} from '../../utils/commons'
import ExpertTopChoicesLogo from './logo'
import {expertTopChoicesStylesUS} from './styles'

const baseConfig = {
  domainName: 'expertstopchoices' as const,
  domainType: 'picks' as const,
  siteName: 'Expert Top Choices',
  favicon: '/favicons/expertstopchoice.png',
}

const localeConfigs = {
  us: {
    measurementId: 'G-FQM9S2V9C8',
    camelCaseUrl: 'ExpertTopChoices.com',
    title: (category: string, _count: string) =>
      `Best ${category} ${getCurrentYear()} in United States | ExpertsTopChoices.com – Trusted Reviews & Top Picks`,
    description: (category?: string, _count?: string) =>
      `At ExpertsTopChoices.com, we review and compare USA's best ${category} for ${getCurrentYear()}. Discover expert insights, verified reviews, and smart buying advice to help you choose with confidence.`,
    styles: expertTopChoicesStylesUS,
    logo: <ExpertTopChoicesLogo className="size-10 shrink-0 tablet:size-8" locale="us" />,
  },
}

export const createConfig = (locale: string = 'us') => {
  const localeConfig = localeConfigs[locale as keyof typeof localeConfigs] || localeConfigs.us
  return {
    ...baseConfig,
    ...localeConfig,
  }
}
